export default __webpack_public_path__ + "b9c017a718cdeb8538b85b43da63bafc.woff2";